export const removeFieldsFromRecord = (record, fieldsToRemove) => {
  return Object.keys(record).reduce((acc, key) => {
    if (!fieldsToRemove.includes(key)) {
      acc[key] = record[key];
    }
    return acc;
  }, {});
};
